import type { Event } from '@patsnap/tahiti-core';

/**
 * 参考锚点查找器
 */
export interface ReferenceAnchorMatcher {
    /**
     * 查找匹配的正则表达式
     */
    matcher: RegExp;
}

/**
 * 参考锚点处理器
 */
export interface ReferenceAnchorHandler {
    /**
     * 处理匹配到的字符串
     * @param unwrap 清除包裹后的字符串
     * @param index 序号
     * @param matched 匹配到的字符串, 清除包裹前的字符串
     * @returns 返回处理后的字符串
     */
    transform(unwrap: string, index: string, matched: string ): string;
}

export const ReferenceAnchorHandler = Symbol('ReferenceAnchorHandler');

export interface UnWrapMatched {
    /**
     * 清除包裹
     * @description [xxx] -> xxx，「xxx」-> xxx
     * @param matched 匹配到的字符串
     * @return 返回清除包裹后的字符串，比如 [xxx] -> xxx
     */
    unwrap(matched: string): string;
}


/**
 * 参考锚点序号生成器
 */
export interface ReferenceAnchorIndexGenerator {
    onStateChange: Event<[string, number]>;
    /**
     * 输入一个字符串，返回一个序号，
     * @description 相同的输入，会返回相同的序号
     * @param matched 匹配到的字符串
     * @return index 序号
     */
    generate(matched: string): string;
    /**
     * 重置序号
     */
    reset(): void;
    [Symbol.iterator](): IterableIterator<[string, number]>;
}

export const ReferenceAnchorIndexGenerator = Symbol('ReferenceAnchorIndexGenerator');

/**
 * 参考锚点格式化选项
 */
export interface ReferenceAnchorFormatOptions extends ReferenceAnchorHandler, UnWrapMatched, ReferenceAnchorMatcher {
    /**
     * 输入一个字符串，返回一个序号，
     * @description 相同的输入，会返回相同的序号
     * @param matched 匹配到的字符串
     * @return index 序号
     */
    generate(matched: string): string;
}

/**
 * 参考锚点
 * @description 有一段文本：其中可能包含某种标记的字符串，比如 [xxx] 需要将这些字符串替换成一个html标签，比如<a id="xxx">{index}</a> 的形式, 其中xxx是标记的字符串，index 可以通过 xxx 的值来确定
 */
export interface ReferenceAnchor {
    /**
     * 格式化文本
     * @param input 原始文本
     * @param options 格式化选项
     * @returns 返回处理后的文本
     */
    format(input: string, options: ReferenceAnchorFormatOptions): string;
}

export const ReferenceAnchor = Symbol('ReferenceAnchor');

